<fin-mmb-unsaved-changes
  [unsavedChangesModalOpen]="unsavedChangesModalOpen"
  (leaveWithoutSaving)="leaveWithoutSaving()"
  (continueEditing)="continueEditing()"
/>
@if (booking$ | async; as booking) {
  <ul class="unstyled">
    @for (pax of booking.passengers; track pax.id; let paxIndex = $index) {
      <li class="pr-small rounded-large border mr-medium-b white-bg" data-testid="mmb-pax-details-passenger-info">
        <h2 class="font-heading-4 nordic-blue-900-text mr-small-b">
          {{ 'paxDetails.passenger' | finLocalization | titlecase }} {{ paxIndex + 1 }}
        </h2>

        <fin-mmb-passenger-info
          (formDirtyStatus)="setPassengerDirtyStatus(pax.id, $event)"
          class="block"
          [paxIndex]="paxIndex + 1"
          [passenger]="pax"
          [passengers]="booking.passengers"
          [controlData$]="controlData$"
          [isMainPax]="(mainPaxInfo$ | finMap: 'id' | async) === pax.id"
          [accompanyingAdult]="getAccompanyingAdult(pax) | async"
          [accompanyingInfant]="getAccompanyingInfant(pax) | async"
          [isSaving$]="updatingPassengers.includes(pax.id) | finToObservable"
          [allFrequentFlyerCards$]="allFrequentFlyerCards$"
          (paxDetailsUpdating)="setUpdatingPassenger(pax.id, $event)"
        />

        <fin-included-product-item
          class="block mr-small-t pr-small-t border-top-dashed"
          [includePaddings]="false"
          [category]="'reservation'"
          [buttonTranslationKey]="'MMB.labels.documentsTitle'"
          [disabled]="updatingPassengers.includes(pax.id)"
        >
          @if (ticketRowsByPaxId$ | finMap: pax.id | async; as ticketRows) {
            @if (ticketRows.length > 0) {
              <fin-mmb-passenger-tickets
                [tickets]="ticketRows"
                [passengerNumber]="paxIndex + 1"
                class="mr-xxsmall-t pr-xxsmall-t"
              />
            }
          }

          <fin-mmb-passenger-emds
            [rows]="emdRowsByPaxId$ | finMap: pax.id | async"
            [passengerNumber]="paxIndex + 1"
            class="mr-xxsmall-t pr-xxsmall-t"
          />
        </fin-included-product-item>

        @if (passengerTierData$ | finMap: pax.id | async; as passengerTierData) {
          <fin-included-product-item
            class="block mr-small-t pr-small-t border-top-dashed"
            category="tier"
            [includePaddings]="false"
            [buttonTranslationKey]="passengerTierData.tierLabel"
            [disabled]="updatingPassengers.includes(pax.id)"
            data-testid="mmb-pax-details-included-tier-benefit"
          >
            <fin-mmb-tier-benefits
              [tier]="getFinnairPlusTier(pax.frequentFlyerCards)"
              [tierBenefits]="passengerTierData.benefits"
            />
          </fin-included-product-item>
        }
      </li>
    }

    @if (!booking.otherInformation.isGroupBooking) {
      <li data-testid="mmb-pax-details-emergency-contact" class="pr-small rounded-large mr-medium-b border white-bg">
        <h2 class="font-heading-4 nordic-blue-900-text mr-small-b">
          {{ 'MMB.labels.emergencyContactDetails' | finLocalization }}
        </h2>

        <fin-mmb-emergency-contact
          (formDirtyStatus)="setEmergencyContactDirtyStatus($event)"
          class="block"
          [emergencyContact]="emergencyContact$ | async"
        />
      </li>
    }
  </ul>
}
